import Animator from './lib/Animator'
export default new Animator()
